import React from "react"
import Typography from "aldoo-ra/Typography"
import TextEditor from "aldoo-ra/CMS/field-editors/text"
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline"
import { showNotification } from "aldoo-ra/Notification"
import useProductEditorTexts from "../useProductEditorTexts"

export default function PIDEditor(props) {
  const { value, parentObject } = props
  const t = useProductEditorTexts()

  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value)
      showNotification({
        message: t`Product ID copied to clipboard`,
        className: "bg-admin_primary text-admin_text_inv",
      })
    }
  }

  // Get parentObject data (handle both object and function)
  const parentData = typeof parentObject === 'function' ? parentObject() : parentObject

  // If the product has an _id, it's been saved, so show as read-only Typography
  if (parentData?._id) {
    return (
      <div
        className="flex items-center gap-2 cursor-pointer text-admin_primary hover:text-admin_primary/80 transition-colors mt-2"
        onClick={handleCopy}
      >
        <Typography variant="admin_body1" className="text-inherit">
          {value || t`N/A`}
        </Typography>
        <ClipboardDocumentIcon className="w-4 h-4" />
      </div>
    )
  }

  // For new products, use default text editor
  return <TextEditor {...props} />
}
